import MUILockIcon from '@mui/icons-material/Lock'

export const LockIcon = MUILockIcon
